<template>
	<div class="staff-staff-form-group">
		<p>{{ group.name }}</p>
		<input-checkbox v-model="model.group" :name="'permissions_group_' + group.id + '_group'" placeholder="Group"/>
		<input-checkbox v-model="model.biometric" :name="'permissions_group_' + group.id + '_biometric'" placeholder="Biometric"/>
		<input-checkbox v-model="model.geofencing" :name="'permissions_group_' + group.id + '_geofencing'" placeholder="Geo Fencing"/>
		<input-checkbox v-model="model.pillbox" :name="'permissions_group_' + group.id + '_pillbox'" placeholder="Pill Box"/>
		<input-checkbox v-model="model.appointments" :name="'permissions_group_' + group.id + '_appointments'" placeholder="Appointments"/>
		<input-checkbox v-model="model.healthreports" :name="'permissions_group_' + group.id + '_healthreports'" placeholder="Health Reports"/>
		<input-checkbox v-model="model.medicaldocuments" :name="'permissions_group_' + group.id + '_medicaldocuments'" placeholder="Medical Documents"/>
		<input-checkbox v-model="model.patient_profile" :name="'permissions_group_' + group.id + '_patient_profile'" placeholder="Profile"/>
		<input-checkbox v-model="model.chat" :name="'permissions_group_' + group.id + '_chat'" placeholder="Chat"/>
	</div>
</template>

<script>
import InputCheckbox from './InputCheckbox'
export default {
	components: {
		InputCheckbox
	},
	props: [
		'group',
		'permissions'
	],
	data () {
		return {
			model: {
				group: false,
				biometric: false,
				geofencing: false,
				pillbox: false,
				appointments: false,
				healthreports: false,
				medicaldocuments: false,
				patient_profile: false,
				chat: false
			}
		}
	},
	watch: {
		permissions: {
			handler (value) {
				if (Array.isArray(value)) {
					value.forEach(element => {
						this.model[element] = true
					})
				}
			},
			deep: true,
			immediate: true
		},
		model: {
			handler () {
				const permissions = []
				for (let key in this.model) {
					if (this.model[key]) {
						permissions.push(key)
					}
				}
				this.$emit('groupPermissionsUpdate', this.group.id, permissions)
			},
			deep: true,
			immediate: true
		}
	}
}
</script>

<style>
.staff-staff-form-group > p {
	color: white;
	background: var(--main-color);
	padding: 15px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/profile/staff/components/StaffStaffFormGroup.vue